import * as React from 'react';
import styled from '@emotion/styled';
import { DropdownItem, DropdownWidget } from '../widgets/menus/DropdownWidget';
import { useOnClickOutside } from '../hooks/useOnClickOutside';
import { useRef } from 'react';
import { useDimension } from '../hooks/useDimension';
import { useWindowSize } from '../hooks/useWindowSize';
import { LayerWidget } from '../layers/LayerWidget';

export interface ClientPos {
  x: number;
  y: number;
}

export interface SmartDropdownWidgetProps {
  items: DropdownItem[];
  targetRefs?: React.MutableRefObject<any>[];
  onClickOutside?: (event: MouseEvent) => any;
  pos: ClientPos;
}

export const DROPDOWN_PADDING = 16;

export const SmartDropdownWidget: React.FC<SmartDropdownWidgetProps> = (props) => {
  const dropdownRef = useRef<HTMLElement>(null);

  useOnClickOutside({
    refs: [dropdownRef, ...(props.targetRefs || [])],
    handler: (event) => {
      props.onClickOutside?.(event);
    }
  });

  let pos = props.pos;

  const dropdownDim = useDimension({ ref: dropdownRef });
  const windowSize = useWindowSize();

  // Check window overflow
  if (dropdownDim.width && windowSize.width) {
    if (props.pos.x + dropdownDim.width > windowSize.width) {
      pos.x = windowSize.width - dropdownDim.width - DROPDOWN_PADDING;
    }
  }
  if (dropdownDim.height && windowSize.height) {
    if (props.pos.y + dropdownDim.height > windowSize.height) {
      pos.y = windowSize.height - dropdownDim.height - DROPDOWN_PADDING;
    }
  }
  return (
    <LayerWidget
      renderLayer={() => {
        return (
          <S.Container pos={pos}>
            <DropdownWidget forwardRef={dropdownRef} items={props.items} />
          </S.Container>
        );
      }}
    />
  );
};

namespace S {
  export const Container = styled.div<{ pos: ClientPos }>`
    position: absolute;
    top: ${(p) => p.pos.y}px;
    left: ${(p) => p.pos.x}px;
  `;
}
